import { Mapper } from "../../../../base/utils/mapper";
import { RipsModel } from "../../../../domain/models/consult/rips.model";
import { RipsEntity } from "../entities/rips-entity";



export class RipsImplementationRepositoryMapper extends Mapper<RipsEntity, RipsModel> {
    mapFrom(param: RipsEntity): RipsModel {
        return {
            data:param.data,
            isSuccess:param.isSuccess,
            message:param.message,
            errors:param.errors
        };
    }
    mapTo(param: RipsModel): RipsEntity {
        return {
            data:param.data,
            isSuccess:param.isSuccess,
            message:param.message,
            errors:param.errors
        }
    }
}